import { createAsyncThunk } from '@reduxjs/toolkit';
import pollModel from 'store/models/polls';
import {
  TargetAsk,
  TPollsListMeta,
  TPollsListResponse,
  TRequesPollstList,
  TUnionPollDetails,
  TUnionPollResult,
} from '../types/pollsSchema';

//GET

export const fetchPollsList = createAsyncThunk(
  'polls/fetchPollsList',
  async (data: TRequesPollstList, { rejectWithValue }) => {
    try {
      const response: {
        data: { data: TPollsListResponse[]; meta: TPollsListMeta };
      } = await pollModel.getPollsList(data);
      return response;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

export const fetchPollDetails = createAsyncThunk(
  'polls/fetchPollDetails',
  async (data: { poll: string; partId?: number }, { rejectWithValue }) => {
    try {
      const response: {
        data: { data: TUnionPollDetails };
      } = await pollModel.getPollDetails(data.poll);
      return response;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

export const verifyPollBookingStatus = createAsyncThunk(
  'polls/verifyPollBookingStatus',
  async (poll: string, { rejectWithValue }) => {
    try {
      const response: {
        data: { data: TUnionPollDetails };
      } = await pollModel.getPollDetails(poll);
      return response.data.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

export const fetchTargetQuestion = createAsyncThunk(
  'polls/fetchTargetQuestion',
  async (_, { rejectWithValue }) => {
    try {
      const response: { data: { data: TargetAsk } } =
        await pollModel.getTargetQuestion();
      return response;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

//POST
export const fetchTargetAnswer = createAsyncThunk(
  'polls/fetchTargetAnswer',
  async (
    data: { question_id: number; answer: string },
    { rejectWithValue },
  ) => {
    try {
      const response = await pollModel.postTargetAnswer(data);
      return response;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

export const postPollResults = createAsyncThunk(
  'polls/postPollResults',
  async (result: TUnionPollResult, { rejectWithValue }) => {
    try {
      // throw new Error('test error in send request');
      const response: {
        data: { data: { target_question: TargetAsk | null } };
      } = await pollModel.postPollResults(result);
      return response;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

export const postPollBook = createAsyncThunk(
  'polls/postPollBook',
  async (poll: string, { rejectWithValue }) => {
    try {
      const response: {
        data: { data: Partial<TUnionPollDetails> };
      } = await pollModel.postPollBook(poll);
      return response;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

export const postPollStart = createAsyncThunk(
  'polls/postPollStart',
  async (poll: string, { rejectWithValue }) => {
    try {
      const response: {
        data: { data: Partial<TUnionPollDetails> };
      } = await pollModel.postPollStart(poll);
      return response;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

export const postPollRefuse = createAsyncThunk(
  'polls/postPollRefuse',
  async (data: { poll: string; reason: string }, { rejectWithValue }) => {
    try {
      const response: unknown = await pollModel.postPollRefuse(data);
      return response;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

export const postPollMedia = createAsyncThunk(
  'polls/postPollMedia',
  async (
    data: {
      pollId: number;
      file: File;
      media_type: 'image' | 'video' | 'audio';
      onChunkProgress?: (progress: number) => void;
      onProcessingProgress?: (progress: number) => void;
      signal?: AbortSignal;
    },
    { rejectWithValue },
  ) => {
    try {
      const response = await pollModel.postTaskMedia(data);
      return response;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

export const fetchPollRun = createAsyncThunk(
  'polls/fetchPollRun',
  async (_, { rejectWithValue }) => {
    try {
      const response: {
        data: {
          data: TUnionPollDetails & {
            run_poll_blocked_before?: string;
            target_question: TargetAsk | null;
          };
        };
      } = await pollModel.postPollRun();
      return response;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);
